/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CandidateAcademicProgramCompletion model module.
 * @module model/CandidateAcademicProgramCompletion
 * @version v1
 */
class CandidateAcademicProgramCompletion {
    /**
     * Constructs a new <code>CandidateAcademicProgramCompletion</code>.
     * @alias module:model/CandidateAcademicProgramCompletion
     */
    constructor() { 
        
        CandidateAcademicProgramCompletion.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CandidateAcademicProgramCompletion</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CandidateAcademicProgramCompletion} obj Optional instance to populate.
     * @return {module:model/CandidateAcademicProgramCompletion} The populated <code>CandidateAcademicProgramCompletion</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CandidateAcademicProgramCompletion();

            if (data.hasOwnProperty('academic_program')) {
                obj['academic_program'] = ApiClient.convertToType(data['academic_program'], 'String');
            }
            if (data.hasOwnProperty('completion')) {
                obj['completion'] = ApiClient.convertToType(data['completion'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} academic_program
 */
CandidateAcademicProgramCompletion.prototype['academic_program'] = undefined;

/**
 * @member {Number} completion
 */
CandidateAcademicProgramCompletion.prototype['completion'] = undefined;






export default CandidateAcademicProgramCompletion;

